export default "__VITE_ASSET__mQ2c1$Ds__"